import React from "react";

const EmailMerges = () => {
  return <div>EmailMerges</div>;
};

export default EmailMerges;
